//Contact form submit
function gtag_report_contact_conversion(url) {
    var callback = function () {
        if (typeof (url) != 'undefined') {
            window.location = url;
        }
    };

    gtag('event', 'conversion', {
        'send_to': 'AW-1000130653/1MpCCL7CvokZEN2Q89wD',
        'event_callback': callback
    });

    return false;
}


//Contact button click
function gtag_report_click_conversion() {
    var callback = function () {
        if (typeof (url) != 'undefined') {
            window.location = url;
        }
    };

    gtag('event', 'conversion', {
        'send_to': 'AW-1000130653/sTBoCPzCqZsZEN2Q89wD',
        'event_callback': callback
    });
    return false;
}

//Footer contact link click
function gtag_report_footer_link_conversion(url) {
    var callback = function () {
        if (typeof (url) != 'undefined') {
            window.location = url;
        }
    };
    gtag('event', 'conversion', {
        'send_to': 'AW-1000130653/KLeNCPawys4ZEN2Q89wD',
        'event_callback': callback
    });
    return false;
}


//Scroll
class ScrollConversion {
    constructor() {
        this.scrollTriggerPos = window.scrollY + 300;
        this.onScrollEventListener = this.convert.bind(this);
        window.addEventListener('scroll', this.onScrollEventListener);
    }

    convert() {
        if (window.scrollY > this.scrollTriggerPos) {
            var callback = function () {
                if (typeof (url) != 'undefined') {
                    window.location = url;
                }
            };

            gtag('event', 'conversion', {
                'send_to': 'AW-1000130653/2l8xCIClr6wZEN2Q89wD',
                'event_callback': callback
            });
            window.removeEventListener('scroll', this.onScrollEventListener);
        }
    }
}

window.addEventListener('DOMContentLoaded', (e) => {
    new ScrollConversion();
});

// Kaldes fra onclick i Views / indhold
window.gtag_report_contact_conversion = gtag_report_contact_conversion;
window.gtag_report_click_conversion = gtag_report_click_conversion;
window.gtag_report_footer_link_conversion = gtag_report_footer_link_conversion;
